"use client";

import { useRouter } from "next/navigation";
import { useEffect } from "react";

import { useAuth } from "@/components/auth/auth-provider";
import { useLocale } from "@/components/providers/locale-provider";
import { Spinner } from "@/components/ui/spinner";

/**
 * لوحة المعلومات, not a report.
 *
 * This used to be General Ledger › Reports, which dropped a signing-in user four levels deep
 * inside one module before they had chosen a department. Signing in now lands on the dashboard;
 * الرئيسية, the department launcher, is its own destination on the menu beside it.
 */
const AFTER_SIGN_IN_PATH = "/dashboard";
const SIGN_IN_PATH = "/login";

/**
 * `/` is a dispatcher, not a screen. The session lives in `localStorage`, so the
 * decision cannot be made on the server — this renders a neutral placeholder for
 * the tick it takes the auth context to settle, then replaces the history entry
 * so `/` never sits in the back stack.
 */
export default function RootPage() {
  const { status } = useAuth();
  const { t } = useLocale();
  const router = useRouter();

  useEffect(() => {
    if (status === "loading") return;
    router.replace(status === "authenticated" ? AFTER_SIGN_IN_PATH : SIGN_IN_PATH);
  }, [router, status]);

  return (
    <div className="flex flex-1 items-center justify-center p-16">
      <Spinner
        size="lg"
        label={t.common.loading}
        className="text-[var(--muted-foreground,#655c58)]"
      />
    </div>
  );
}
